import React, { useEffect, useState } from 'react'
// import TableComponent from './Table';
import { AiFillDelete } from "react-icons/ai";
import expand from "../utils/expand.png";
import products from "../utils/products.png";
import delete_Vector from "../utils/delete_Vector.jpg";
// useEffect
const Contacts = () => {
  
  const [rows, setRows] = useState([]); // Initialize state

  // Retrieve data from localStorage on component mount
  useEffect(() => {
    const savedContacts = localStorage.getItem("leadContacts");
    console.log('savedContacts',savedContacts)
    if (savedContacts) {
      setRows(JSON.parse(savedContacts)); // ✅ Store retrieved data in state
    }
  }, []); // ✅ Runs only once when the component mounts

  // Save data to localStorage whenever `rows` changes
  // useEffect(() => {
  //   if (rows?.length > 0) {
  //     localStorage.setItem("leadContacts", JSON.stringify(rows));
  //   }
  // }, [rows]); // ✅ Runs every time `rows` updates


    console.log('rows:',rows)
    const [selectedLeads, setSelectedLeads] = useState([]); // State to track selected leads
    const [selectedLead, setSelectedLead] = useState(null); // Track selected lead for the modal
    const [filteredLeadRows, setFilteredLeadRows] = useState(rows);
    const [showDeleteModal, setShowDeleteModal] = useState(false); // To control the visibility of the modal
    const [viewLeadModal, setViewLeadModal] = useState(false);
    // const [showStatusModal, setShowStatusModal] = useState(false); // To control the visibility of the modal
  
    const onDeleteChecked = () => {
      console.log("reached on delete in table 235");
      setShowDeleteModal(true);
    };

        
  const handleInputChange = (id, field, value) => {
    console.log('handleInputChange ...')
    setFilteredLeadRows((prev) =>
      prev?.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleViewLead = (lead) => {
    setSelectedLead(lead);
    // console.log("lead 195 handle view:", lead);
    setViewLeadModal(true);
  };

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };



  // const statusMapping = {
  //   newLead: "New Lead",
  //   contacted: "Contacted",
  //   attemptedToContact: "Attempted",
  //   qualified: "Qualified",
  //   unQualified: "Unqualified",
  // };
    

  // const openStatusModal = (lead) => {
  //   setSelectedLead(lead);
  //   // console.log("lead 187 open status:", lead);
  //   setShowStatusModal(true);
  // };

  const closeDeleteModal = () => {
    setShowDeleteModal(false); // Close modal
  };


    const deleteSelectedLeads = () => {
      console.log('inside deleteSelectedLeads')
      const updatedLeads = filteredLeadRows.filter(
        (lead) => !selectedLeads.includes(lead.id)
      );
      setFilteredLeadRows(updatedLeads);
      setRows((prevRows) =>
        prevRows.filter((lead) => !selectedLeads.includes(lead.id))
      );
      setSelectedLeads([]); // Clear selected leads after deletion
      setShowDeleteModal(false); // Close modal after deletion
    };

  return (
    <>
    <div className='px-4 text-xl font-normal'>
      Contacts
    </div>


            <div>
              {selectedLeads.length > 0 && (
                <div className="mb-2">
                  <button
                    onClick={onDeleteChecked}
                    className="bg-red-500 text-white px-2 py-2 rounded mr-2"
                    disabled={selectedLeads.length === 0}
                  >
                    {/* Delete Selected */}
                    {/* <img src={deleteIcon} alt="delete-icon" className="w-3 h-3 text-white" /> */}
                    <AiFillDelete size={18} />
                  </button>
                </div>
              )}
              <div className="overflow-x-hidden max-w-full mt-1  max-h-[60vh] overflow-y-auto scrollbar-thin px-4">
                <table className="table-auto w-[100%] border-collapse border border-gray-200">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="shadow-sm px-1 py-0.5 text-left">
                        <input
                          type="checkbox"
                          className="rounded border border-sm shadow"
                          onChange={(e) =>
                            setSelectedLeads(
                              e.target.checked
                                ? filteredLeadRows?.map((row) => row.id)
                                : []
                            )
                          }
                          checked={
                            selectedLeads.length > 0 &&
                            selectedLeads.length === filteredLeadRows.length
                          }
                        />
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        <span className="ml-6">Lead</span>
                      </th>
                      {/* <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Status
                      </th> */}
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Organization
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Title
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Email
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Phone
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left font-normal">
                        Notes
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white px-2">
                    {filteredLeadRows?.map((row) => (
                      <tr
                        key={row.id}
                        // ref={row.id === editingRowId ? newRowRef : null}
                        className={` ${
                          selectedLeads.includes(row.id) ? "bg-blue-100" : ""
                        }`}
                      >
                        <td className="shadow-sm px-1 py-0.5 text-center">
                        <div className=" flex justify-between items-center gap-0">
    
                          <input
                            type="checkbox"
                            className="rounded border border-sm"
                            checked={selectedLeads.includes(row.id)}
                            onChange={() =>
                              setSelectedLeads((prev) =>
                                prev.includes(row.id)
                                  ? prev.filter((id) => id !== row.id)
                                  : [...prev, row.id]
                              )
                            }
                          />
    
                          {row.leadIsItemAdded && (
                            <img
                              src={products}
                              alt="products-icon"
                              className="w-1 h-1 bg-green-500 text-xs p-1 ml-0.5 rounded-lg"
                            />
                          )}
                          </div>
                        </td>
    
                        <td className="shadow-sm px-1 py-0.5 ">
                          <div className="flex items-center justify-around  ">
                            <input
                              type="text"
                              value={row.lead}
                              onChange={(e) =>
                                handleInputChange(row.id, "lead", e.target.value)
                              }
                              // autoFocus={row.id === editingRowId}
                              className=" outline-none w-auto p-0 border-none text-sm bg-transparent"
                            />
    
                            <div className="flex items-center  justify-center gap-2">
                              <img
                                onClick={() => handleViewLead(row)}
                                src={expand}
                                alt="expand-icon"
                                className="w-4 h-4 cursor-pointer"
                              />
                              <div className="text-xs font-thin bg-gray-400 px-0.5 rounded-lg text-white">
                                {calculateAgedDays(row.leadEntryTime)}
                              </div>
                            </div>
                          </div>
                        </td>
    
                        {/* <td
                          className="shadow-sm px-1 py-0.5 cursor-pointer"
                          onClick={() => openStatusModal(row)}
                        >
                          {row.status && (
                            <button
                              // onClick={() => updateStatusToQualified(row.id)}
                              className={`w-full text-white text-center p-1 rounded ${
                                row.status === "newLead"
                                  ? "bg-orange-400"
                                  : row.status === "contacted"
                                  ? "bg-blue-600"
                                  : row.status === "attemptedToContact"
                                  ? "bg-red-400"
                                  : row.status === "qualified"
                                  ? "bg-green-400"
                                  : row.status === "unQualified"
                                  ? "bg-red-600"
                                  : "bg-gray-300" // default case if no match
                              }`}
                            >
                              {statusMapping[row.status] || row.status}{" "}
                            </button>
                          )}
                        </td> */}
    
                        <td className="shadow-sm px-1 py-0.5">
                          <input
                            type="text"
                            value={row.organization}
                            onChange={(e) =>
                              handleInputChange(
                                row.id,
                                "organization",
                                e.target.value
                              )
                            }
                            className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                          />
                        </td>
    
    
    
                        <td className="shadow-sm px-1 py-0.5">
                          <input
                            type="text"
                            value={row.title}
                            onChange={(e) =>
                              handleInputChange(row.id, "title", e.target.value)
                            }
                            className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                          />
                        </td>
    
                        <td className="shadow-sm px-1 py-0.5">
                          <input
                            type="email"
                            value={row.email}
                            onChange={(e) =>
                              handleInputChange(row.id, "email", e.target.value)
                            }
                            className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                          />
                        </td>
    
                        <td className="shadow-sm px-1 py-0.5">
                          <input
                            type="text"
                            value={row.phone}
                            onChange={(e) =>
                              handleInputChange(row.id, "phone", e.target.value)
                            }
                            className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                          />
                        </td>
    
                        <td className="shadow-sm px-1 py-0.5">
                          <input
                            type="text"
                            value={row.notes}
                            onChange={(e) =>
                              handleInputChange(row.id, "notes", e.target.value)
                            }
                            className="bg-transparent outline-none w-full block p-0 border-none text-sm "
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
       

             {/* Modal for deleting lead  */}
             {showDeleteModal && (
               <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
                 <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center relative">
                   {/* Image Section */}
                   <div className="flex justify-center mb-2">
                     <img
                       src={delete_Vector}
                       alt="Delete Icon"
                       className="w-1/4 h-auto max-w-xs"
                     />
                   </div>
       
                   {/* Close Button */}
                   <button
                     className="absolute top-6 right-8 text-gray-500 hover:text-black"
                     onClick={closeDeleteModal}
                   >
                     ✖
                   </button>
       
                   {/* Title Section */}
                   <div className="text-xl font-semibold text-black">
                     {selectedLeads.length === 1 ? "Lead Selected" : "Leads Selected"}
                   </div>
                   <div className="text-gray-700 mb-6">
                     {/* Display different message based on the number of selected rows */}
                     {selectedLeads.length === 1 ? (
                       <span className="font-bold">
                         {/* Are you sure you want to delete {checkedLead}{" "} */}
                         Are you sure you want to delete {selectedLeads.lead}?
                       </span>
                     ) : (
                       <span className="font-bold">
                         Are you sure you want to delete {selectedLeads.length} leads?
                       </span>
                     )}
                   </div>
       
                   {/* Action Buttons */}
                   <div className="flex justify-center space-x-4">
                     {/* Delete Button */}
                     <button
                       className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                       onClick={deleteSelectedLeads} // Call delete function
                     >
                       Delete
                     </button>
       
                     {/* Cancel Button */}
                     <button
                       className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                       onClick={closeDeleteModal}
                     >
                       Cancel
                     </button>
                   </div>
                 </div>
               </div>
             )}
    </>

  )
}

export default Contacts
